var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDSignalHeatingPumpVariableDP1 = function SvgDSignalHeatingPumpVariableDP1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 656,
    y: 336,
    width: 20,
    height: 28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675,337v26h-18v-26h18M676,336h-20v28h20v-28h0Z",
    fill: "#1c9d5b"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "661.62 351 671.85 340.76 671.15 340.06 661 350.2 661 339.5 660 339.5 660 352 672.5 352 672.5 351 661.62 351"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M663.4,354.34h.95l2.24,5.69h-5.53l2.34-5.69ZM662.4,359.24h2.88l-1.41-3.73-1.47,3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.71,357.96c0,.65-.15,1.17-.45,1.56s-.7.58-1.2.58c-.46,0-.83-.15-1.11-.46v2h-.95v-5.85h.88l.04.43c.28-.34.66-.51,1.14-.51.52,0,.92.19,1.21.58s.44.92.44,1.6v.06ZM669.77,357.88c0-.42-.08-.76-.25-1s-.41-.37-.72-.37c-.39,0-.67.16-.84.48v1.88c.17.33.45.49.84.49.3,0,.54-.12.71-.37s.26-.61.26-1.11Z"
  }))))));
};
export default SvgDSignalHeatingPumpVariableDP1;